<template>
    <div class="reset-container">
        <!-- 左右标题信息 -->
        <div class="bg-logo">
            <img src="../../../public/img/logo.svg" alt="Element logo" @click="$router.push('/')" />
        </div>
        <img src="../../../public/img/lg01.svg" class="lg01">
        <div class="header">Reset Password</div>
        <div class="tip">Please reset your account password by entering ConfChair's bound email address</div>
        <div class="input-box">
            <el-input v-model="restinfo.email" placeholder="account email" class="input-item">
                <template #prefix>
                    <el-icon class="el-input__icon">
                        <Message />
                    </el-icon>
                </template>
            </el-input>
            <el-input v-model="restinfo.code" placeholder="email verification code" class="input-item">
                <template #prefix>
                    <el-icon class="el-input__icon">
                        <Lock />
                    </el-icon>
                </template>
                <template #append>
                    <el-button :icon="Position" @click="sendCode"/>
                </template>
            </el-input>
            <el-input v-model="restinfo.newpassword" placeholder="new password" class="input-item">
                <template #prefix>
                    <el-icon class="el-input__icon">
                        <Lock />
                    </el-icon>
                </template>
            </el-input>
            <el-input v-model="restinfo.renewpassword" placeholder="Confirm the new password again" class="input-item">
                <template #prefix>
                    <el-icon class="el-input__icon">
                        <Refresh />
                    </el-icon>
                </template>
            </el-input>
            <el-button type="primary" @click="modify">reset password</el-button>

        </div>
    </div>
</template>

<script setup>
import { Message, Lock, Refresh,Position } from '@element-plus/icons-vue'
import { ref } from 'vue'
import { ElMessage } from 'element-plus'
import request from "../../network/request"


const restinfo = ref({})


// 发送验证码给用户
const sendCode = () =>{
    console.log(restinfo.value);
    if (restinfo.value.email == "" || restinfo.value.email == null) {
        ElMessage({
            message: `Email cannot be empty`,
            type: 'warning',
        })
        return
    }
    request.post("/user/code",{
        email:restinfo.value.email
    }).then(res => {
        if (res.code == 200) {
            ElMessage({
                message: `Verification code has been sent`,
                type: 'success',
            })
        } else {
            ElMessage({
                message: res.msg,
                type: 'warning',
            })
        }
    })

}

// 修改密码
const modify = () => {
    if (restinfo.value.newpassword != restinfo.value.renewpassword) {
        ElMessage({
            message: `The new password entered twice does not match`,
            type: 'warning',
        })
        return
    }
    request.post("/user/reset", restinfo.value).then(res => {
        if (res.code == 200) {
            ElMessage({
                message: `modified successfully`,
                type: 'success',
            })
        } else {
            ElMessage({
                message: res.msg,
                type: 'warning',
            })
        }
    })
}


</script>

<style lang="scss">
.reset-container {
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    flex-direction: column;
    background: linear-gradient(180deg, #bdddf7c0 0%, rgba(255, 255, 255, 1) 100%);
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;

    .lg01 {
        position: fixed;
        width: 20%;
        opacity: .3;
        bottom: -5%;
        right: -5%;
    }

    .header {
        font-size: 30px;
        font-weight: 700;
        color: #40485B;
    }

    .tip {
        color: #8C92A4;
        margin-top: 20px;
        font-size: 13px;
    }

    .input-box {
        margin-top: 20px;
        display: flex;
        flex-direction: column;

        .el-input {
            width: 350px;
            height: 40px;
            margin-bottom: 10px;
        }
    }

    .bg-logo {
        display: flex;
        color: #4584b7ae;
        font-weight: 700;
        position: absolute;
        top: 32px;
        left: 40px;

        img {
            width: 145px;
            cursor: pointer;
        }
    }

}
</style>